
import React, { useEffect, useState } from 'react';
import DialogActions from '@mui/material/DialogActions';
import { MenuItem, Checkbox, ListItemText, TextField, TextareaAutosize, Stack, Typography, Grid, Paper, List, ListItem, Box } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import axios from '../../../utils/fvAxios';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { IconButton } from '@mui/material'

import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import _ from "lodash";
import { ToastContainer, toast } from 'react-toastify';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import CloseIcon from '@mui/icons-material/Close';

export default function ExpiredVendorEmailPage({ DialogClose, Locations, ClientId, INFO }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };
    const [CCandBCCInfo, setCCandBCCInfo] = useState([]);
    const [CCID, setCCID] = useState([]);
    const [BCCID, setBCCID] = useState([]);
    const [LocationsList, setLocationsList] = React.useState([]);
    const [VendorTypeList, setVendorTypeList] = React.useState([]);

    const [To, setTo] = useState("");
    const [Cc, setCc] = useState("");
    const [BCc, setBCc] = useState("");
    const [Body, setBody] = useState("");
    const [Comment, setComment] = useState("");
    const [VendorEmails, setVendorEmails] = useState("");
    const [Location, setLocation] = useState([]);
    const [Ccerror, setCcError] = useState("");
    const [BCcerror, setBCcError] = useState("");
    const [Toerror, setToError] = useState("");
    const [MySelfCC, setMySelfCC] = useState(false);
    const [MySelfBCc, setMySelfBCc] = useState(false);
    const [VendorTypeId, setVendorTypeId] = React.useState("");

    const [DisInvitation, setDisInvitation] = React.useState(false);

    useEffect(() => {
        Details();
    }, []);

    async function Details() {
        const res = await axios.get("MyAccount/GetCCAndBCCListForEmailVendor?orgID=" + ClientId);
        setCCandBCCInfo(res?.data?.data);

        axios.get("Common/GetLocationsByClientId?clientId=" + ClientId)
            .then((resp) => {
                setLocationsList(resp?.data?.data);
            }).catch(err => {
                console.log(err);
            })

        axios.get("AdminVendors/GetInvitationTemplateAndToEmail?clientId=" + ClientId + "&vendorId=" + INFO?.orgId)
            .then((respon) => {
                setBody(respon?.data?.data?.item1);
                setTo(respon?.data?.data?.item2);
            }).catch(err => {
                console.log(err);
            })

        axios.post("/Client/GetClientContractTypes?clientId=" + ClientId)
            .then((re) => {
                setVendorTypeList(re?.data?.data?.item2);
            }).catch(err => {
                console.log(err);
            })

    }
    const [open, setOpen] = React.useState(false);
    const DialogOpenClick = () => {
        // setTo("info@firstverify.com");
        setCc(CCID.toString());
        setBCc(BCCID.toString());
        setOpen(true);
    };
    const DialogCloseClick = () => {
        setOpen(false);
    };

    const ChangeBody = (data) => {
        setBody(data);
    }
    const ChangeTo = (e) => {
    const regex = /^[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,20}$/;
        let result = e.target.value.split(",");
        result.forEach((em) => {
            if (regex.test(em) == true) {
                setToError("");
                setTo(e.target.value);
            } else {
                setToError("Please check email");
                setTo(e.target.value);
            }

        });

    }
    const ChangeCc = (e) => {
        const regex = /^[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,20}$/;
        let result = e.target.value.split(",");
        result.forEach((em) => {
            if (regex.test(em) == true) {
                setCcError("");
                setCc(e.target.value);
            } else {
                setCcError("Please check email");
                setCc(e.target.value);
            }

        });

    }
    const ChangeBCc = (e) => {
        const regex = /^[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,20}$/;
        let result = e.target.value.split(",");
        result.forEach((em) => {
            if (regex.test(em) == true) {
                setBCcError("");
                setBCc(e.target.value);
            } else {
                setBCcError("Please check email");
                setBCc(e.target.value);
            }

        });

    }
    const [OpenPopup, setOpenPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    const formatBlockedEmailMessage = (message) => {
        if (!message) return null;

        const blockedMatch = message.match(/BlockedEmails:\s*\(\s*(.*?)\s*\)/);
        const unBlockedMatch = message.match(/UnBlockedEmails:\s*\(\s*(.*?)\s*\)/);

        return {
            description:
                "Some recipients could not be processed because their email addresses are blocked. The remaining recipients will receive the email.",
            blockedEmails: blockedMatch?.[1]
                ?.split(",")
                .map(x => x.trim())
                .filter(Boolean) || [],
            unBlockedEmails: unBlockedMatch?.[1]
                ?.split(",")
                .map(x => x.trim())
                .filter(Boolean) || []
        };
    };

    const Clear = () => {
        setTo("");
        setCc("");
        setBCc("");
        setBody("");
        setComment("");
        setLocation("");
        setMySelfCC(false);
        setMySelfBCc(false);
        setCCID([]);
        setBCCID([]);
        setVendorTypeId("");
        setVendorTypeList([]);
        DialogClose();
        DialogCloseClick();

    }
    const SendEmail = async () => {
        setDisInvitation(true);
        if (To != "" && Toerror == "" && Ccerror == "" && BCcerror == "") {
            const data = {
                "vendorId": INFO?.orgId,
                "invitationType": 1,
                "locations": Location?.toString(),
                "riskLevel": "Select Risk Level",
                "comments": Comment,
                "isSendMeCC": MySelfCC,
                "isSendMeBCC": MySelfBCc,
                "sendCC": Cc,
                "sendBCC": BCc,
                "toAddress": To,
                "htmlTemplate": Body,
                "clientId": ClientId,
                "pqId": INFO?.pqId,
                "isERI": false,
                "clientContractId": VendorTypeId == "" ? 0 : VendorTypeId
            }
            const res = await axios.post("AdminVendors/PostOutsideInvitation", data);
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.responseMessage, true);
                Clear();
                setDisInvitation(false);
            } else {
                const message = res?.data?.responseMessage ?? "";

                if (message.includes("BlockedEmails:")) {
                    setPopupMessage(formatBlockedEmailMessage(message));
                    setOpenPopup(true);
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                    setDisInvitation(false);
                }

            }
        } else {
            toastNotify("Please Enter the Mandatory fields", false);
            setDisInvitation(false);
        }
    }

    const formats = [
        "strike",
        "size",
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'background',
        'list',
        'align',
        // 'link',
        // 'image',
        'color',
        'indent',
        'clean',
        'blockquote', 'script'

    ];

    const modules = {
        toolbar: [
            ['undo', 'redo'],
            [{ 'size': [] }],
            [{ 'font': [] }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            // ['link'],
            ['clean'],

            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
        ],
    };



    const handleUndo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.undo();
    };

    const handleRedo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.redo();
    };
    const quillRef = React.createRef();

    return (
        <>
            <ToastContainer />

            <Dialog open={OpenPopup} onClose={() => setOpenPopup(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Email Invitation Status</DialogTitle>

                <DialogContent dividers>
                    <Typography sx={{ fontWeight: 600, mb: 5 }}>
                        {popupMessage?.description}
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 2,
                                    height: "100%"
                                }}
                            >
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "error.main", mb: 1 }}>
                                    Blocked Recipients
                                </Typography>

                                <List dense disablePadding>
                                    {popupMessage?.blockedEmails?.map((email, index) => (
                                        <ListItem key={index} disableGutters sx={{ alignItems: "flex-start", py: 0.5 }}>

                                            <Box sx={{ width: 16, flexShrink: 0, fontSize: "1rem", lineHeight: 1.5 }}>
                                                •
                                            </Box>

                                            <Typography variant="body2" sx={{ flex: 1, whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "break-word" }}>
                                                {email}
                                            </Typography>

                                        </ListItem>
                                    ))}
                                </List>
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 2,
                                    height: "100%"
                                }}
                            >
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "success.main", mb: 1 }}>
                                    Recipients
                                </Typography>

                                <List dense disablePadding>
                                    {popupMessage?.unBlockedEmails?.map((email, index) => (
                                        <ListItem key={index} disableGutters sx={{ alignItems: "flex-start", py: 0.5 }}>

                                            <Box sx={{ width: 16, flexShrink: 0, fontSize: "1rem", lineHeight: 1.5 }}>
                                                •
                                            </Box>

                                            <Typography variant="body2" sx={{ flex: 1, whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "break-word" }}>
                                                {email}
                                            </Typography>

                                        </ListItem>
                                    ))}
                                </List>

                            </Paper>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                        variant="contained"
                        className="login-button-request"
                        onClick={() => {
                            setOpenPopup(false);
                            Clear();
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog fullScreen={fullScreen} open={open} onClose={DialogCloseClick}>
                <div style={{ marginLeft: "auto" }}>
                    <span className='mx-2' onClick={DialogCloseClick} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
                </div>
                <DialogContent sx={{ padding: "48px 48px" }} >
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span style={{ fontSize: "larger" }} >{INFO?.orgName}</span>
                    </DialogTitle>

                    <DialogActions >
                        <div>
                            <DialogActions >
                                <div>
                                    <div className='mt-3' >
                                        <span style={{ color: "#3E4A62" }}>To <span style={{ color: "red" }}>*</span></span>
                                        <br />

                                        <TextField
                                            placeholder="TO"
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                backgroundColor: "#fff",
                                                marginTop: "2px",
                                                marginBottom: "5px",
                                            }}

                                            variant="outlined"
                                            size="small"
                                            value={To || ""}
                                            onChange={(e) => ChangeTo(e)}

                                        />
                                    </div>
                                    <p style={{ color: "red" }}>{Toerror}</p>
                                    <div className='mt-3'>
                                        <span style={{ color: "#3E4A62" }}> CC </span>

                                        <br />

                                        <TextField

                                            placeholder="CC"
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                backgroundColor: "#fff",
                                                marginTop: "2px",
                                                marginBottom: "5px",
                                            }}

                                            variant="outlined"
                                            size="small"
                                            value={Cc || ""}
                                            onChange={(e) => ChangeCc(e)}

                                        />

                                    </div>
                                    <p style={{ color: "red" }}>{Ccerror}</p>
                                    <div className='mt-3'>
                                        <span style={{ color: "#3E4A62" }}> BCC  </span>
                                        <br />

                                        <TextField

                                            placeholder="BCC"
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                backgroundColor: "#fff",
                                                marginTop: "2px",
                                                marginBottom: "5px",
                                            }}

                                            variant="outlined"
                                            size="small"
                                            value={BCc || ""}
                                            onChange={(e) => ChangeBCc(e)}

                                        />

                                    </div>
                                    <p style={{ color: "red" }}>{BCcerror}</p>
                                    <div style={{ width: "500px" }}>

                                        <div>
                                            <IconButton onClick={handleUndo} sx={{ marginBottom: "-64px" }}>
                                                <UndoIcon />
                                            </IconButton>
                                            <IconButton onClick={handleRedo} sx={{ marginBottom: "-64px" }}>
                                                <RedoIcon />
                                            </IconButton>

                                            <ReactQuill
                                                ref={quillRef}
                                                theme="snow"
                                                modules={modules}
                                                formats={formats}
                                                value={Body}
                                                onChange={setBody}
                                            />
                                        </div>
                                    </div>
                                    <DialogActions >
                                        <div className="login-help__buttonContainer mt-4">
                                            <Button variant="contained" className="login-help-button-cancel mx-2" onClick={DialogCloseClick}>Cancel</Button>
                                            <Button variant="contained" className="login-button-request mx-2" disabled={DisInvitation} onClick={SendEmail}> Send Invitation</Button>
                                        </div>

                                    </DialogActions>
                                </div >
                            </DialogActions>
                        </div>
                    </DialogActions>
                </DialogContent>

            </Dialog>

            <DialogContent sx={{ width: "Auto", padding: "48px 48px" }}>
                <DialogTitle
                    sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: 20,
                        inlineSize: "350px"
                    }}
                >
                    <span style={{ fontSize: "larger" }} >{INFO?.orgName}</span>
                </DialogTitle>

                <DialogActions >
                    <div>
                        <div className='mt-3' >
                            <span style={{ color: "#3E4A62" }}>Location</span>
                            <br />

                            <Select
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small'
                                sx={{ width: "300px", overflow: "hidden" }}
                                name="Site Safety Representive"
                                value={Location || []}
                                MenuProps={MenuProps}
                                renderValue={(selected) =>
                                    selected
                                        .map((value) => LocationsList?.find((doc) => doc?.value === value)?.key)
                                        .filter((text) => text !== undefined)
                                        .join(", ")
                                }
                                onChange={(e) => setLocation(e.target.value)}
                            >
                                <MenuItem key="Select All" hidden={LocationsList?.length == 0}>
                                    <Checkbox
                                        id="select-all-checkbox"
                                        indeterminate={
                                            Location?.length > 0 && Location?.length < LocationsList?.length
                                        }
                                        checked={Location?.length === LocationsList?.length}
                                        onChange={(event) => {
                                            if (event?.target?.checked) {
                                                setLocation(LocationsList?.map((doc) => doc?.value));
                                            } else {
                                                setLocation([]);
                                            }
                                        }}
                                    />
                                    <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                        Select All
                                    </label>
                                </MenuItem>

                                {LocationsList?.map((r, i) => (
                                    <MenuItem key={i} value={r?.value}>
                                        <Checkbox checked={Location?.indexOf(r?.value) > -1} />
                                        <ListItemText primary={r?.key} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>

                        <div className='mt-3'>
                            <span style={{ color: "#3E4A62" }}>Vendor Type </span>
                            <br />
                            <Select
                                sx={{ width: "300px", overflow: "hidden" }}
                                labelId="demo-multiple-name-label"
                                value={VendorTypeId || ""}
                                id="demo-multiple-name"
                                size="small"
                                onChange={(e) => setVendorTypeId(e.target.value)}
                                MenuProps={MenuProps}
                                disabled={VendorTypeList?.length == 0}
                            >
                                {VendorTypeList?.map((r, i) =>
                                    <MenuItem key={i} value={r?.key} > {r?.value}</MenuItem>
                                )}
                            </Select>
                        </div>

                        <div className='mt-3' >
                            <span style={{ color: "#3E4A62" }}>Comments </span>
                            <br />
                            <TextareaAutosize
                                minRows={3}
                                id="Comments"
                                name="Comments"
                                placeholder="Comments"
                                className="form-control text-feild-custom "
                                size='small'
                                value={Comment || ""}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </div>
                        <div className='mt-3' >
                            <Stack direction={"row"} spacing={11}>
                                <span style={{ color: "#3E4A62" }}>Send via CC to </span>
                                <Stack direction={"row"} spacing={2}>
                                    <span className="input-label-right text-muted" >Myself</span>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Checkbox checked={MySelfCC} onChange={(e) => setMySelfCC(e.target.checked)} size="medium" />}
                                        />
                                    </FormGroup>
                                </Stack>
                            </Stack>
                            <br />
                            <Select
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small'
                                sx={{ width: "300px", overflow: "hidden" }}
                                name="Site Safety Representive"
                                value={CCID || []}
                                MenuProps={MenuProps}
                                renderValue={(selected) =>
                                    selected
                                        .map((key) => CCandBCCInfo?.find((doc) => doc?.key === key)?.value)
                                        .filter((value) => value !== undefined)
                                        .join(", ")
                                }
                                onChange={(e) => setCCID(e.target.value)}
                            >
                                {CCandBCCInfo?.map((r) => (
                                    <MenuItem key={r?.key} value={r?.key}>
                                        <Checkbox checked={CCID?.indexOf(r?.key) > -1} />
                                        <ListItemText primary={r?.value} />

                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className='mt-3'>
                            <Stack direction={"row"} spacing={10}>
                                <span style={{ color: "#3E4A62" }}>Send via BCC to  </span>
                                <Stack direction={"row"} spacing={2}>
                                    <span className="input-label-right text-muted" >Myself</span>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Checkbox checked={MySelfBCc} onChange={(e) => setMySelfBCc(e.target.checked)} size="medium" />}
                                        />
                                    </FormGroup>
                                </Stack>
                            </Stack>
                            <br />

                            <Select
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small'
                                sx={{ width: "300px", overflow: "hidden" }}
                                name="Site Safety Representive"
                                value={BCCID || []}
                                MenuProps={MenuProps}
                                renderValue={(selected) =>
                                    selected
                                        .map((key) => CCandBCCInfo?.find((doc) => doc?.key === key)?.value)
                                        .filter((value) => value !== undefined)
                                        .join(", ")
                                }
                                onChange={(e) => setBCCID(e.target.value)}
                            >
                                {CCandBCCInfo?.map((r) => (
                                    <MenuItem key={r?.key} value={r?.key}>
                                        <Checkbox checked={BCCID?.indexOf(r?.key) > -1} />
                                        <ListItemText primary={r?.value} />

                                    </MenuItem>
                                ))}
                            </Select>

                        </div>
                        <DialogActions >
                            <div className="login-help__buttonContainer mt-4">
                                <Button variant="contained" className="login-help-button-cancel mx-2" onClick={DialogClose}>Cancel</Button>
                                <Button variant="contained" className="login-button-request mx-2" onClick={DialogOpenClick}> Next</Button>
                            </div>

                        </DialogActions>
                    </div >
                </DialogActions>
            </DialogContent >
        </>
    )
}
